// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"0873c562","232":"f34508de","237":"0f5e1ac2","526":"43e322aa"}[chunkId] + ".chunk.js";
};